import React from "react";
import dineroDisabledMask from "./dineroDisabledMask";
import round2Decimals from "./round2Decimals";
import { cuadrePorProyecto } from "../Utils/cuadrePoliza";

const ROJO_DESCUADRE = "#cf1322";

// La clase .table trae margin-top y table-layout: fixed, que dentro de la tarjeta de totales
// de GeneralFormLayout deja la tabla descuadrada y con scroll horizontal de mas.
// Ojo: nada de className="totales-table" aqui — esa hoja esconde en movil el primer <tr> del
// primer <tbody> dando por hecho que ahi va el encabezado, y estas tablas si traen <thead>.
const ESTILO_TABLA = {
  borderCollapse: "collapse",
  width: "100%",
  margin: 0,
  tableLayout: "auto",
};

// Pie de totales de la poliza manual, compartido por PolizaManual y EditarPolizaManual.
//
// Con un solo proyecto es la tabla de siempre (Total Cargos / Total Abonos / Saldo). Con
// varios, se convierte en el mismo desglose que ya imprime el PDF (src/Pdf/polizaPdf.js):
// un renglon por proyecto con su Diferencia, que tiene que dar cero en cada uno.
const TotalesCuadrePoliza = ({ cargosAbonos, proyectoId, multiProyecto, nombreProyecto }) => {
  if (!cargosAbonos) return null;

  const grupos = cuadrePorProyecto(cargosAbonos, proyectoId);

  const totalCargos = grupos.reduce(
    (total, grupo) => round2Decimals(total + grupo.cargos),
    0
  );
  const totalAbonos = grupos.reduce(
    (total, grupo) => round2Decimals(total + grupo.abonos),
    0
  );
  const totalDiferencia = round2Decimals(totalCargos - totalAbonos);

  if (!multiProyecto) {
    return (
      <table className="table" style={ESTILO_TABLA}>
        <thead>
          <tr>
            <th className="th-totales" style={{ width: "33%" }}>
              Total Cargos
            </th>
            <th className="th-totales" style={{ width: "33%" }}>
              Total Abonos
            </th>
            <th className="th-totales" style={{ width: "33%" }}>
              Saldo
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="td-totales-right" style={{ width: "50%" }}>
              {dineroDisabledMask(totalCargos)}
            </td>
            <td className="td-totales-right" style={{ width: "50%" }}>
              {dineroDisabledMask(totalAbonos)}
            </td>
            <td className="td-totales-right" style={{ width: "50%" }}>
              {dineroDisabledMask(Math.abs(totalDiferencia))}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  const estiloDiferencia = (diferencia) =>
    diferencia !== 0 ? { color: ROJO_DESCUADRE, fontWeight: "bold" } : {};

  return (
    <table className="table" style={ESTILO_TABLA}>
      <thead>
        <tr>
          <th className="th-totales" style={{ width: "34%", textAlign: "left" }}>
            Proyecto
          </th>
          <th className="th-totales" style={{ width: "22%" }}>
            Cargos
          </th>
          <th className="th-totales" style={{ width: "22%" }}>
            Abonos
          </th>
          <th className="th-totales" style={{ width: "22%" }}>
            Diferencia
          </th>
        </tr>
      </thead>
      <tbody>
        {grupos.map((grupo) => (
          <tr key={grupo.proyectoId || "sinProyecto"}>
            <td className="td-totales-right" style={{ textAlign: "left" }}>
              {nombreProyecto(grupo.proyectoId)}
            </td>
            <td className="td-totales-right">{dineroDisabledMask(grupo.cargos)}</td>
            <td className="td-totales-right">{dineroDisabledMask(grupo.abonos)}</td>
            <td className="td-totales-right" style={estiloDiferencia(grupo.diferencia)}>
              {dineroDisabledMask(grupo.diferencia)}
            </td>
          </tr>
        ))}
        <tr>
          <td className="td-totales-right" style={{ textAlign: "left", fontWeight: "bold" }}>
            TOTAL
          </td>
          <td className="td-totales-right" style={{ fontWeight: "bold" }}>
            {dineroDisabledMask(totalCargos)}
          </td>
          <td className="td-totales-right" style={{ fontWeight: "bold" }}>
            {dineroDisabledMask(totalAbonos)}
          </td>
          <td className="td-totales-right" style={{ fontWeight: "bold", ...estiloDiferencia(totalDiferencia) }}>
            {dineroDisabledMask(totalDiferencia)}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TotalesCuadrePoliza;
